import _extends from "@babel/runtime/helpers/esm/extends";
import { fieldsIBaseModel } from './base';
import { EModel } from './model';
export let ETelehealthStatus;
(function (ETelehealthStatus) {
  ETelehealthStatus["Scheduled"] = "scheduled";
  ETelehealthStatus["Created"] = "created";
  ETelehealthStatus["InProgress"] = "in-progress";
  ETelehealthStatus["NoShow"] = "no-show";
  ETelehealthStatus["Ended"] = "ended";
})(ETelehealthStatus || (ETelehealthStatus = {}));
export let ETelehealthVendors;
(function (ETelehealthVendors) {
  ETelehealthVendors["Twilio"] = "twilio";
  ETelehealthVendors["Zoom"] = "zoom";
})(ETelehealthVendors || (ETelehealthVendors = {}));
export let ESourceType;
(function (ESourceType) {
  ESourceType["Scheduled"] = "scheduled";
  ESourceType["AdHoc"] = "ad-hoc";
})(ESourceType || (ESourceType = {}));
export let EConnectionType;
(function (EConnectionType) {
  EConnectionType["Bluetooth"] = "bluetooth";
  EConnectionType["Cellular"] = "cellular";
  EConnectionType["Ethernet"] = "ethernet";
  EConnectionType["Mixed"] = "mixed";
  EConnectionType["None"] = "none";
  EConnectionType["Other"] = "other";
  EConnectionType["Unknown"] = "unknown";
  EConnectionType["Wifi"] = "wifi";
  EConnectionType["Wimax"] = "wimax";
})(EConnectionType || (EConnectionType = {}));
export let ETelehealthAppointmentIntegratorUpdateStatus;
(function (ETelehealthAppointmentIntegratorUpdateStatus) {
  ETelehealthAppointmentIntegratorUpdateStatus["Success"] = "success";
  ETelehealthAppointmentIntegratorUpdateStatus["Failure"] = "failure";
  ETelehealthAppointmentIntegratorUpdateStatus["Pending"] = "pending";
})(ETelehealthAppointmentIntegratorUpdateStatus || (ETelehealthAppointmentIntegratorUpdateStatus = {}));
export const fieldsTelehealth = _extends({}, fieldsIBaseModel, {
  appointment: {
    type: 'ID',
    ref: EModel.Appointment
  },
  appointmentType: {
    type: 'ID',
    ref: EModel.AppointmentType
  },
  duration: {
    type: 'Number'
  },
  endedAt: {
    type: 'Date'
  },
  endedBy: {
    type: 'ID',
    ref: EModel.User
  },
  facility: {
    type: 'ID',
    ref: EModel.Facility
  },
  guests: {
    type: 'ID',
    ref: EModel.Guest,
    array: true
  },
  integratorUpdateResults: {
    type: 'Object'
  },
  noShowParticipants: {
    type: 'ID',
    ref: EModel.User,
    array: true
  },
  participants: {
    type: 'ID',
    ref: EModel.User,
    array: true
  },
  password: {
    type: 'Text'
  },
  patient: {
    type: 'ID',
    ref: EModel.Patient
  },
  patientArrivedAt: {
    type: 'Date'
  },
  patientNotifiedAt: {
    type: 'Date'
  },
  patientWaitingSince: {
    type: 'Date'
  },
  provider: {
    type: 'ID',
    ref: EModel.Provider
  },
  providerArrivedAt: {
    type: 'Date'
  },
  providerNotifiedAt: {
    type: 'Date'
  },
  sessionDetails: {
    type: 'Object'
  },
  source: {
    type: 'Option',
    values: ESourceType
  },
  staff: {
    type: 'ID',
    ref: EModel.User
  },
  status: {
    type: 'Option',
    values: ETelehealthStatus
  },
  vendor: {
    type: 'Option',
    values: ETelehealthVendors
  }
});